import {gql} from '@apollo/client';

export const QUERY_STORIES = gql`
query stories($filters: StoryFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
    stories(filters: $filters,pagination: $pagination, sort: $sort) {
        documentId
        identifier
        description
        file {
            documentId
            name
            url
            mime
        }
        createdAt
        updatedAt
    }
}`

export const MUTATION_CREATE_STORY = gql`
    mutation createStory($data: StoryInput!) {
        createStory(data: $data) {
            documentId
        }
    }
`
